function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
export function dataAttributesFilter(props) {
  var dataAttributes = Object.keys(props).reduce(function (acc, propKey) {
    return propKey.includes('data-') ? _objectSpread({}, acc, _defineProperty({}, propKey, props[propKey])) : acc;
  }, {});
  return dataAttributes;
}
export function ariaAttributesFilter(props) {
  var dataAttributes = Object.keys(props).reduce(function (acc, propKey) {
    return propKey.includes('aria-') ? _objectSpread({}, acc, _defineProperty({}, propKey, props[propKey])) : acc;
  }, {});
  return dataAttributes;
}